<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "headingPlant" v-if="mode==='CREATE'">Create DO</md-dialog-title>
      <md-dialog-title class = "headingPlant" v-if="mode==='UPDATE'">Modify DO</md-dialog-title>
      <md-dialog-title class = "headingPlant" v-if="mode==='COPY'">Copy DO</md-dialog-title>
      <md-dialog-title class = "headingPlant" v-if="mode==='delete'">Delete Load</md-dialog-title>
     
      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">

          <callingApiCenter  type="bar" :paths="['/api/w/do/doheader/action']"></callingApiCenter>
          <md-dialog-actions >
            <md-button class="md-raised" @click="cancalAction"><span class="icons-center material-icons">cancel</span>Cancel</md-button>
            <md-button type="submit" class="md-raised md-primary"><span class="icons-center material-icons">create</span>Save</md-button>
          </md-dialog-actions>
      


          <div class = "down">
            <div class = "inputBoxDouble" >
              <div v-if="mode=='CREATE' || mode=='COPY'" class = "inputBoxSpace">
                <auto-complete-master-data-select
                                            group="GST_SALEOFFICE" 
                                            label="Sale Office" 
                                            :init-value="dataForm.salesOffice" 
                                            :on-item-changed="handleSaleOfficeChanged">
                </auto-complete-master-data-select>
                <!--
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.salesOffice')"
                                            group="GST_SALEOFFICE" 
                                            label="Sale Office" 
                                            :init-value="dataForm.salesOffice" 
                                            :on-item-changed="handleSaleOfficeChanged">
                </auto-complete-master-data-select>
              -->
              </div>
              <div v-if="mode=='UPDATE'"  class = "inputBoxSpace">
                <md-field >
                  <label size="lg" class = "textlabel" for="salesOffice">Sales Office</label>
                  <md-input name="salesOffice" id="salesOffice" autocomplete="new-password" v-model="dataForm.salesOffice" disabled ref = "top"/>
                </md-field>
              </div>
              <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="GST_DELIVERYTYPE" label="Delivery Type" :init-value="dataForm.deliveryType" :on-item-changed="handleDeliveryTypeChanged" >
                </auto-complete-master-data-select>
                <!--
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.deliveryType')"
                  group="GST_DELIVERYTYPE" label="Delivery Type" :init-value="dataForm.deliveryType" :on-item-changed="handleDeliveryTypeChanged" >
                </auto-complete-master-data-select>
              -->
              </div>
              <div class = "inputBoxSpace">
                <!--
                <md-field :class="getValidationClass('dataForm.agreement')">
                -->  
                <md-field>
                  <label size="lg" class = "textlabel" for="agreement">Rate Agreement</label>
                  <md-input name="agreement" id="agreement" autocomplete="new-password" v-model="dataForm.agreement" ref = "top"/>
                </md-field>
              </div>
              <div  class = "inputBoxSpace" :class="getValidationClass('dataForm.erdat_mp')">
                <datepicker v-model="dataForm.erdat_mp">
                  <label>Sales Order Date</label>
                </datepicker>
              </div>
              <!-- <div class = "inputBoxSpace">
                  <auto-complete-master-data-select :class="getValidationClass('dataForm.status')"
                                                group="STC_DO_STATUS"
                                                label="Process"
                                                :init-value="status"
                                                :on-item-changed="handleDOStatusChanged"
                                                >
                  </auto-complete-master-data-select>
              </div> -->
              <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="STC_DO_STATUS" label="Process" :init-value="dataForm.deleteBit" :on-item-changed="handleDOStatusChanged">
                </auto-complete-master-data-select>
                <!--
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.deleteBit')"
                  group="STC_DO_STATUS" label="Process" :init-value="dataForm.deleteBit" :on-item-changed="handleDOStatusChanged">
                </auto-complete-master-data-select>
              -->
              </div>              
            </div>

            <div class = "inputBoxDouble" >
     

              <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="STC_CUSTOMER" label="Customer" :init-value="dataForm.custID" :on-item-changed="handleCustIDChanged">
                </auto-complete-master-data-select>
                <!--
                <auto-complete-master-data-select :class="getValidationClass('dataForm.custID')"
                  group="STC_CUSTOMER" label="Customer" :init-value="dataForm.custID" :on-item-changed="handleCustIDChanged">
                </auto-complete-master-data-select>
              -->
              </div>
              <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="STC_CUSTOMER" label="Bill To" :init-value="dataForm.billTo" :on-item-changed="handleBillToChanged" >
                </auto-complete-master-data-select>
                <!--
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.billTo')"
                  group="STC_CUSTOMER" label="Bill To" :init-value="dataForm.billTo" :on-item-changed="handleBillToChanged" >
                </auto-complete-master-data-select>
              -->
              </div>
              <div class = "inputBoxSpace">
                  <md-field >
                    <label size="lg" class = "textlabel" for="customerPO">Customer PO/Ref#.</label>
                    <md-input name="customerPO" id="customerPO" autocomplete="new-password" v-model="dataForm.customerPO" ref = "top"/>
                  </md-field>
              </div>

              <div class = "inputBoxSpace">
                <md-field >
                  <label size="lg" class = "textlabel" for="bookObl">Book/OBL/Other</label>
                  <md-input name="bookObl" id="bookObl" autocomplete="new-password" v-model="dataForm.bookObl" ref = "top"/>
                </md-field>
              </div>
              <div class = "inputBoxSpace">
                <!--
                <md-field :class="getValidationClass('dataForm.arktx')">
                -->
                  <md-field>  
                  <label size="lg" class = "textlabel" for="arktx">Material/Description</label>
                  <md-input name="arktx" id="arktx" autocomplete="new-password" v-model="dataForm.arktx" ref = "top"/>
                </md-field>
              </div>
            </div>


            <div class = "inputBoxDouble" >
              <div class = "inputBoxSpace">
                <md-field>
                  <label size="lg" class = "textlabel" for="zz_hqname">Supplier</label>
                  <md-input name="zz_hqname" id="zz_hqname" autocomplete="new-password" v-model="dataForm.zz_hqname" ref = "top"/>
                </md-field>
              </div>
              <div class = "inputBoxSpace">
                <md-field >
                  <label size="lg" class = "textlabel" for="sort1">Sort</label>
                  <md-input name="sort1" id="sort1" autocomplete="new-password" v-model="dataForm.sort1" ref = "top"/>
                </md-field>
              </div> 
              <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="STC_CARRIER" label="Carrier" :init-value="dataForm.scac" :on-item-changed="handleScacChanged">
                </auto-complete-master-data-select>
              </div>
              <div class = "inputBoxSpace">
                <md-field >
                  <label size="lg" class = "textlabel" for="vesselName">Vessel Name</label>
                  <md-input name="vesselName" id="vesselName" autocomplete="new-password" v-model="dataForm.vesselName" ref = "top"/>
                </md-field>
              </div>
              <div class = "inputBoxSpace">
                <md-field >
                  <label size="lg" class = "textlabel" for="voyage">Voyage</label>
                  <md-input name="voyage" id="voyage" autocomplete="new-password" v-model="dataForm.voyage" ref = "top"/>
                </md-field>
              </div>
            </div> 


            <div class = "inputBoxDouble" >
              <div  class = "inputBoxSpace">
                <datepicker v-model="dataForm.erd">
                  <label>ERD Date</label>
                </datepicker>
              </div>

              <div  class = "inputBoxSpace">
                <md-field :class="getValidationClass('dataForm.erdTime')">
                  <label>ERD Time</label>
                  <md-input v-model="dataForm.erdTime" placeholder="Format: HH:MM:SS"></md-input>
                </md-field>
              </div>

              <div  class = "inputBoxSpace" >
                <datepicker v-model="dataForm.docCut" :class="getValidationClass('dataForm.docCut')">
                  <label>Doc Cutoff</label>
                </datepicker>
              </div>

             <div  class = "inputBoxSpace" >
                <!--
                <datepicker v-model="dataForm.cutLFD" :class="getValidationClass('dataForm.cutLFD')">
                -->
                  <datepicker v-model="dataForm.cutLFD">
                  <label>Cutoff/LFD/Delivery Date</label>
                </datepicker>
                <div>
                  <!--<div class="md-error" v-if="!$v.dataForm.cutLFD.required">Cutoff/LFD Date is required<br/></div>-->
                </div>
              </div>

              <div  class = "inputBoxSpace">
                <md-field :class="getValidationClass('dataForm.cutLFDTime')">
                  <label>Cutoff/LFD/Delivery Time</label>
                  <md-input v-model="dataForm.cutLFDTime" placeholder="Format: HH:MM:SS"></md-input>
                </md-field>
              </div>

            </div>


            <div class = "inputBoxDouble" >
              

              <div class = "inputBoxSpace">
                <!--
                <div :class="getValidationClass('dataForm.pickupLoc')">
                -->
                <div> 
                  <autocomplete-ccic-location-select
                  label="Pickup Location" group="STC_TERMINAL" v-model="dataForm.pickupLoc" :on-item-selected="handlePickLocationChanged"/>
                  <!--<span class="md-error" v-if="!$v.dataForm.pickupLoc.required">Pickup Location is required</span>-->
                </div>
                <div v-if="dataForm.pickupLoc">
                  <div>{{dataForm.pickUpLocationName}}</div>
                </div>
              </div> 

              <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="STC_TERMINAL" label="Pickup Tml" :init-value="dataForm.ctnrPickup" :on-item-changed="handleCtnrPickupChanged">
                </auto-complete-master-data-select>
              </div> 
 
              <div class = "inputBoxSpace">
                <!--<div :class="getValidationClass('dataForm.deliveryTo')">-->
                <div>
                  <autocomplete-ccic-location-select
                  label="Delivery Location" group="STC_TERMINAL" v-model="dataForm.deliveryTo" :on-item-selected="handleDeliveryLocationChanged"/>
                  <!--<span class="md-error" v-if="!$v.dataForm.deliveryTo.required">Delivery Location is required</span>-->
                </div>
                <div v-if="dataForm.deliveryTo">
                  <div>{{dataForm.deliverLocationName}}</div>
                </div>
              </div>

              <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="STC_TERMINAL" label="DropOff Tml" :init-value="dataForm.ctnrDropOff" :on-item-changed="handleCtnrDropOffChanged">
                </auto-complete-master-data-select>
              </div>


            </div>
   
          <div class = "inputBoxDouble" >
            <div class = "inputBoxSpace">
                <auto-complete-master-data-select
                  group="CCR_CNTRTYPE" label="Container Type" :init-value="dataForm.ctnrType" :on-item-changed="handleCtnrTypeChanged">
                </auto-complete-master-data-select>
                <!--
                <auto-complete-master-data-select  :class="getValidationClass('dataForm.ctnrType')"
                  group="CCR_CNTRTYPE" label="Container Type" :init-value="dataForm.ctnrType" :on-item-changed="handleCtnrTypeChanged">
                </auto-complete-master-data-select>
              -->
              </div>

              <div class = "inputBoxSpace">
                <!--<md-field :class="getValidationClass('dataForm.ctnrCount')">-->
                <md-field>  
                  <label size="lg" class = "textlabel" for="ctnrCount">Ctnr Count</label>
                  <md-input name="ctnrCount" id="ctnrCount" autocomplete="new-password" v-model="dataForm.ctnrCount" ref = "top"/>
                </md-field>
              </div>

              <div class = "inputBoxSpace">
                    <md-field>
                      <label size="lg" class = "textlabel" for="zzsclost">Scale</label>
                      <md-select v-model="dataForm.zzsclost">
                        <md-option value="X">Offsite</md-option>
                        <md-option value=" ">Onsite</md-option>
                      </md-select>
                    </md-field>
              </div>
            </div>


            <div class = "inputBoxDouble" >
              <div class = "inputBoxSpaceWide">
                <md-field >
                  <label size="lg" class = "textlabel" for="customerPO">BK Remark</label>
                  <md-input name="remark_bsi" id="remark_bsi" autocomplete="new-password" v-model="dataForm.remark_bsi" ref = "top"/>
                </md-field>
              </div>
            </div>


          </div>
        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
/* @import '../../public/chrisForm.css'; */

form {
  min-width: 1000px;
  margin: 5px;
}

.headingPlant {
  padding-top: 0;
  padding-left: 0;
  margin-bottom: 0;
  color: #1131e7;
  line-height: 1;
  font-size: 24px;
  font-family: Roboto Slab;
  margin-left: 10px;
}

.layoutPlant {
  padding-bottom: 0;
  line-height: 0;
  color: #555555;
  font-family: Roboto Slab;
  margin: 0;
}

.inputBoxDouble {
  width: 1000px;
  height: 80px;
  display: flex;
  flex-direction: row;
}

.inputBoxSpace {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 0;
}

.inputBoxSpaceWide {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 1000px;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 0;
}

.inputBoxOutbound {
  border: 1px solid #cacbcc;
  border-radius: px;
  color: #29303b;
  font-size: 12px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}

.inputBoxButton {
  width: 160px;
  display: inline-block;
  padding: 0px 10px;
}
  
.cl .md-field{
  display: inline-block !important;
  width: auto;
  margin-bottom: 0;
  padding-top:0;
}

.cl .md-field .md-input {
  font-size: 14px !important;
}

.custSearchBar {
  height: 35px;
  margin: 10px !important;
  vertical-align:top;
}


</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

    import dateFormat from '../utils/dateFormat';

    

  const getInitialdataForm = () => ({
    action: 'NEW',
    deliveryOrder: null,
    salesOffice: "LGB",
    deliveryStatus:"I",
    deliveryType: null,
    customerPO: null,
    erdat_mp: moment(new Date()).format('M/D/YYYY'),
    erd: moment(new Date()).format('M/D/YYYY'),
    // erd: null,
    erdTime: "00:00:00",
    cutLFD: moment(new Date()).format('M/D/YYYY'),
    // cutLFD: null,
    cutLFDTime: "00:00:00",
    docCut: moment(new Date()).format('M/D/YYYY'),
    bookObl: null,
    ctnrCount: null,
    ctnrAssign: "0",
    ctnrType: null,
    pickUpLocation: null,
    pickupLoc: null,
    pickUpLocationName: null,
    deliverLocation: null,
    deliveryTo: null,
    deliverLocationName: null,
    ctnrPickup: null,
    ctnrDropOff: null,
    scac: null,
    vesselName: null,
    voyage: null,
    custID: null,
    billTo: null,
    arktx: null,
    zzsclost: null,
    acname: null,
    zz_hqname: null,
    zv_tel_numbe: null,
    zv_cel_numbe: null,
    carpn: null,
    tdlnr: null,
    remark_bsi: null,
    agreement: null,
    rate: null,
    waers: null,
    deleteBit: null,
    createdAt: null,
    createTime: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null,
    selected: true,


  });

  const getInitAgreement = () => ({
    salesOffice: null,
    agreement: null
  });


  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),

      loadList: [],
      dispatchers: [],
      ccicQcUsers: [],
      searchRequest: getInitAgreement(),
      status: [],
      saleofficeEmpty: false,
      deliverytypeempty: false,
      ctnrtypeempty: false,
      ctnrcountempty: false,
      arktxempty: false,
      pickuplocempty: false,
      deliverytoempty: false,
      cutlfdempty: false,
      custidempty: false,
      billtoempty: false,
      agreementempty: false,
      deletebitempty: false,
     
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
      
    },

    validations: {
      dataForm: {
        // salesOffice: {required,},
        // deliveryType: {required,},
        // ctnrType: {required,},
        // ctnrCount: {required,},
        // arktx: {required,},
        // pickupLoc: {required,},
        // deliveryTo: {required,},
        // cutLFD: {required,},
        // custID: {required,},
        // billTo: {required,},
        // agreement: {required,},
        // deleteBit: {required,},

        erdTime:{
            required,
            add : (value) => {
              
              const res = moment('2021-04-01T' + value).toDate();
              return res != 'Invalid Date';
            }
        },
        cutLFDTime:{
            required,
            add : (value) => {
              
              const res = moment('2021-04-01T' + value).toDate();
              return res != 'Invalid Date';
            }
        },
      },



    },

 
    methods: {



      openDialog(existingUser) {
        this.$store.commit('clearApiError');
       
       
        this.$v.dataForm.$reset();

        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
      
        if (existingUser) {
         console.log(existingUser);

        //  this.dataForm.action = 'UPDATE';
         this.dataForm = existingUser;
         this.dataForm.cutLFDTime = dateFormat.time(existingUser.cutLFD);
         this.dataForm.cutLFD = dateFormat.date(existingUser.cutLFD);
         this.dataForm.erdTime = dateFormat.time(existingUser.erd);
         this.dataForm.erd = dateFormat.date(existingUser.erd);
         this.dataForm.erdat_mp = dateFormat.date(existingUser.erdat_mp);
         this.dataForm.docCut = dateFormat.date(existingUser.docCut);
         console.log("opendialog doheader form deleteBit: " + this.dataForm.deleteBit);

         if (this.dataForm.deleteBit && this.dataForm.deleteBit != "") {
            this.status = this.getMasterDataName("STC_DO_STATUS", this.dataForm.deleteBit);
            // console.log("opendialog doheader form deleteBit status: " + this.status);
         }  

         if (this.mode == "COPY") {
          this.dataForm.ctnrCount = "0";
          this.dataForm.ctnrAssign = "0";
          this.dataForm.deleteBit = "T";
         }

        }

        this.showDialog = true;
      },

      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      handleStatusChanged(id, name) {
        console.log(`handleStatusChanged`, id, name);
        this.dataForm.loadStatus = id;
        //this.dataForm.loadStatus = name;
      },

      handleDOStatusChanged(id, name) {
        console.log("handleDOStatusChanged" + id, name);
        this.dataForm.deleteBit = id;
        // this.status = name;
      },

      handleScacChanged(id, name){
          console.log(`handleScacChanged`, id, name);
        this.dataForm.scac = id;
      },

      handleCtnrPickupChanged(id, name){
          console.log(`handleCtnrPickupChanged`, id, name);
        this.dataForm.ctnrPickup = id;
      },

      handleCtnrDropOffChanged(id, name){
          console.log(`handleCtnrDropOffChanged`, id, name);
        this.dataForm.ctnrDropOff = id;
      },


      handleCustIDChanged(id, name){
          console.log(`handleCustIDChanged`, id, name);
        this.dataForm.custID = id;
      },

      handleBillToChanged(id, name){
          console.log(`handleBillToChanged`, id, name);
        this.dataForm.billTo = id;
      },


      handleSaleOfficeChanged(id, name){
        console.log(`handleSaleOfficeChanged`, id, name);
        this.dataForm.salesOffice = id;
      },

      handleCtnrTypeChanged(id, name){
        console.log(`handleCtnrTypeChanged`, id, name);
        this.dataForm.ctnrType = id;
      },

      handleDeliveryTypeChanged(id, name){
        console.log(`handledDeliveryTypeChanged`, id, name);
        this.dataForm.deliveryType = id;
      },

      handlePickLocationChanged(item) {
        if (item) {
          
          this.dataForm.pickUpLocation = item;
          this.dataForm.pickupLoc = item.tagId;
          this.dataForm.pickUpLocationName = item.tagName;
        } else {
          this.dataForm.pickUpLocation = null;
          this.dataForm.pickupLoc = null;
          this.dataForm.pickUpLocationName = null;
        }
      },


      handleDeliveryLocationChanged(item) {
        if (item) {
          
          this.dataForm.deliverLocation = item;
          this.dataForm.deliveryTo = item.tagId;
          this.dataForm.deliverLocationName = item.tagName;
        } else {
          this.dataForm.deliverLocation = null;
          this.dataForm.deliveryTo = null;
          this.dataForm.deliverLocationName = null;
        }
      },

      getMasterDataByName(group, tagId) {
        //console.log("get master data name: " + group + ", " + tagId);
        if (!tagId) {
          return "";
        }
        //console.log("master name: " + this.getMasterDataName(group, tagId));
        return this.getMasterDataName(group, tagId);
        //return "";
      },

      cancalAction(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },

      // checkSaleOfficeField()
      // {
      //   if (this.dataForm.salesOffice == null || this.dataForm.salesOffice == "")
      //   {
      //     this.saleofficeEmpty = true;
      //     return true;
      //   } else {
      //     this.saleofficeEmpty = false;
      //     return false;
      //   }
      // },
      // check
      // checkRequiredFields()
      // {
      //     var hasEmptyField = false;
      //     if (this.dataForm.salesOffice == null || this.dataForm.salesOffice == "")
      //     {
      //       hasEmptyField = true;
      //       this.saleofficeEmpty = true;
      //     } else {
      //       this.saleofficeEmpty = false;
      //     }
      //     if (this.dataForm.deliveryType == null || this.dataForm.deliveryType == "")
      //     {
      //       hasEmptyField = true;
      //       this.deliverytypeempty = true;
      //     } else {
      //       this.deliverytypeempty = false;
      //     }
      //     if (this.dataForm.ctnrType == null || this.dataForm.ctnrType == "")
      //     {
      //       hasEmptyField = true;
      //       this.ctnrtypeempty = true;
      //     } else {
      //       this.ctnrtypeempty = false;
      //     }
      //     if (this.dataForm.ctnrCount == null || this.dataForm.ctnrCount == "")
      //     {
      //       hasEmptyField = true;
      //       this.ctnrcountempty = true;
      //     } else {
      //       this.ctnrcountempty = false;
      //     }
      //     if (this.dataForm.arktx == null || this.dataForm.arktx == "")
      //     {
      //       hasEmptyField = true;
      //       this.arktxempty = true;
      //     } else {
      //       this.arktxempty = false;
      //     }
      //     if (this.dataForm.pickupLoc == null || this.dataForm.pickupLoc == "")
      //     {
      //       hasEmptyField = true;
      //       this.pickuplocempty = true;
      //     } else {
      //       this.pickuplocempty = false;
      //     }
      //     if (this.dataForm.deliveryTo == null || this.dataForm.deliveryTo == "")
      //     {
      //       hasEmptyField = true;
      //       this.deliverytoempty = true;
      //     } else {
      //       this.deliverytoempty = false;
      //     }
      //     if (this.dataForm.cutLFD == null || this.dataForm.cutLFD == "")
      //     {
      //       hasEmptyField = true;
      //       this.cutlfdempty = true;
      //     } else {
      //       this.cutlfdempty = false;
      //     }
      //     if (this.dataForm.custID == null || this.dataForm.custID == "")
      //     {
      //       hasEmptyField = true;
      //       this.custidempty = true;
      //     } else {
      //       this.custidempty = false;
      //     }
      //     if (this.dataForm.billTo == null || this.dataForm.billTo == "")
      //     {
      //       hasEmptyField = true;
      //       this.billtoempty = true;
      //     } else {
      //       this.billtoempty = false;
      //     }
      //     if (this.dataForm.agreement == null || this.dataForm.agreement == "")
      //     {
      //       hasEmptyField = true;
      //       this.agreementempty = true;
      //     } else {
      //       this.agreementempty = false;
      //     }
      //     if (this.dataForm.deleteBit == null || this.dataForm.deleteBit == "")
      //     {
      //       hasEmptyField = true;
      //       this.deletebitempty = true;
      //     } else {
      //       this.deletebitempty = false;
      //     }
      //     return hasEmptyField;

      // },

      async doSaveUser() {

        if (this.dataForm.salesOffice == null || this.dataForm.salesOffice == "")
        {
           alert("Sale Office is required!");
           return;
        }
        if (this.dataForm.deliveryType == null || this.dataForm.deliveryType == "")
        {
           alert("Delivery Type is required!");
           return;
        }
        if (this.dataForm.ctnrType == null || this.dataForm.ctnrType == "")
        {
           alert("Container Type is required!");
           return;
        }
        if (this.dataForm.ctnrCount == null || this.dataForm.ctnrCount == "")
        {
           alert("Container Count is required!");
           return;
        }
        if (this.dataForm.arktx == null || this.dataForm.arktx == "")
        {
           alert("Grade is required!");
           return;
        }
        if (this.dataForm.pickupLoc == null || this.dataForm.pickupLoc == "")
        {
           alert("Pickup Location is required!");
           return;
        }
        if (this.dataForm.deliveryTo == null || this.dataForm.deliveryTo == "")
        {
           alert("Delivery To is required!");
           return;
        }
        if (this.dataForm.cutLFD == null || this.dataForm.cutLFD == "")
        {
           alert("Cutoff Date is required!");
           return;
        }
        if (this.dataForm.custID == null || this.dataForm.custID == "")
        {
           alert("Customer PO is required!");
           return;
        }
        if (this.dataForm.billTo == null || this.dataForm.billTo == "")
        {
           alert("Bill To is required!");
           return;
        }
        if (this.dataForm.agreement == null || this.dataForm.agreement == "")
        {
           alert("Agreement is required!");
           return;
        }
        if (this.dataForm.deleteBit == null || this.dataForm.deleteBit == "")
        {
           alert("Delete Bit is required!");
           return;
        }

        this.$v.dataForm.$touch();

        this.searchRequest.salesOffice = this.dataForm.salesOffice;
        this.searchRequest.agreement = this.dataForm.agreement;
        if (this.searchRequest.agreement != null){
          //const agrementResult = await api.post('/api/w/gst/gstpriceagreement/search', this.searchRequest)
          const agrementResult = await newAPIPost('/api/w/gst/gstpriceagreement/search', this.searchRequest)
            if ( agrementResult.length < 1 ){
              window.confirm('Rate Agreement number ' + this.dataForm.agreement + ' not found!')
                return;
            };
        }
 
  


        //this.$v.dataForm.$touch();

        // console.log(this.mode);
        // console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);
        // console.log(`Form data is ${JSON.stringify(this.dataForm)}`)


        const erdTimeRef = moment('2021-04-01T' + this.dataForm.erdTime).format('HH:mm:ss');
        this.dataForm.erd = dateFormat.getLocalDateOnly(this.dataForm.erd) + 'T' + erdTimeRef;
        const cutLFDTRef = moment('2021-04-01T' + this.dataForm.cutLFDTime).format('HH:mm:ss');
        this.dataForm.cutLFD = dateFormat.getLocalDateOnly(this.dataForm.cutLFD) + 'T' + cutLFDTRef;
        this.dataForm.docCut = dateFormat.getLocalDateOnly(this.dataForm.docCut) + 'T00:00:00';



        
        // console.log("do header form save deletebit: " + this.dataForm.deleteBit);
        if (this.mode == "CREATE" || this.mode == "COPY"){
          this.dataForm.action = 'NEW';
        }
        if (this.mode == "UPDATE"){

          if ( parseInt(this.dataForm.ctnrCount) < parseInt(this.dataForm.ctnrAssign)) {
            window.confirm('Ctnr Count (' + this.dataForm.ctnrCount + ') cannot less then Ctnr Assign (' + this.dataForm.ctnrAssign + ')!')
            return;
          }
          if ( parseInt(this.dataForm.ctnrCount) == parseInt(this.dataForm.ctnrAssign) ) {
            this.dataForm.deliveryStatus = 'C';
          }
          if ( parseInt(this.dataForm.ctnrCount) > parseInt(this.dataForm.ctnrAssign) ) {
            this.dataForm.deliveryStatus = 'I';
          }

          this.dataForm.action = 'UPDATE';
        }

        if (this.$v.dataForm.$invalid) {
         this.$refs.top.$el.focus();
          return;
        }

  

        // console.log("do header form save deletebit: " + this.dataForm.deleteBit);

        this.$store.dispatch('saveDoheader', this.dataForm)
        .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            $('.btn-search-do-header')
              .click();
          });


      },
    },
  };
</script>
